import "../styles/Home.css"

function Home() {

    return (
        <div className="body body-home">
            <div className="content">
                <h1 className="title">Site web en construction</h1>

                <p className="text">
                    Ce site internet est actuellement en cours de développement. Vous pouvez revenir voir l'avancement quand vous voulez !
                </p>

                <a className="button" target="_blank" href="https://www.kedysa-studios.com" rel="noopener noreferrer">
                    Visiter Kédysa Studios
                </a>
            </div>
        </div>
    )

}

export default Home